type JsonApiErrorFormat = {
  code: string;
  detail: string;
  status: string;
  title: string;
};

const UNKNOWN_ERROR_CODE = 'UnknwonError';

const defaultUnknownError = {
  code: UNKNOWN_ERROR_CODE,
  detail: 'Unknown Error',
  status: '500',
  title: 'Unknown Error',
};

class JsonApiError extends Error {
  errors: JsonApiErrorFormat[];
  constructor(errors: JsonApiErrorFormat[]) {
    super('JsonApiError');
    // if for some reason `errors` is undefined, set it to a default unknown value
    this.errors = errors ?? [defaultUnknownError];
  }
}

export { JsonApiError, UNKNOWN_ERROR_CODE };
export type { JsonApiErrorFormat };
